import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { listOrgs, createOrg } from '@/api/orgs';

export function useOrgs() {
  return useQuery({ queryKey: ['orgs'], queryFn: () => listOrgs() });
}

export function useCreateOrg() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => createOrg(name),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['orgs'] }),
  });
}
